
import { Pages } from '../../components/Pages/Pages';
import { ApplicationState } from '../../domain/types';
import useApplicationStateRefresh from '../../hooks/useApplicationStateRefresh';
import { useAuthentication } from '../../hooks/useAuthentication';
import AccountInfoPage from '../../pages/AccountInfoPage/AccountInfoPageSE';
import ErrorPage from '../../pages/ErrorPage/ErrorPage';
import PpiPage from '../../pages/PpiPage/PpiPageSE';
import SelectOfferPage from '../../pages/SelectOfferPage/SelectOfferPage';
import OngoingStaticPage from '../../pages/StatusPage/OngoingStaticPage';

const OngoingApplicationWizardNO = () => {
    useAuthentication();
    const { isError, applicationState } = useApplicationStateRefresh();

    if (isError) {
        return <ErrorPage />;
    }

    const getPage = () => {
        switch (applicationState) {
            case 'ACCEPT_OFFER_MAIN_APPLICANT':
                return <SelectOfferPage />;
            case 'DISBURSEMENT_ACCOUNT_INFORMATION_MAIN_APPLICANT':
                return <AccountInfoPage />;
            case 'PPI_MAIN_APPLICANT':
                return <PpiPage />;
            default:
                return <OngoingStaticPage applicationState={applicationState as ApplicationState} />;
        }
    };

    return <Pages>{getPage()}</Pages>;
};

export default OngoingApplicationWizardNO;
